import { handleRequests } from '@/helpers';

export const CarrierMarketplaceMixin = {
    methods: {
        /**
         *
         * @param {number[]} orderIds
         * @param {import("axios").CancelToken} cancellationToken
         * @returns {Promise<import("@/jsDocTypes/Carrier").OrderServiceRatesResponse | null>}
         */
        async $_carrierMarketplace_getOrderServiceRates(orderIds, cancellationToken) {
            if (orderIds.length === 0) {
                return null;
            }
            const searchParams = new URLSearchParams();
            orderIds.forEach((orderId) => {
                searchParams.append('orderIds', orderId.toString());
            });

            const endpoint = `/api/carrier-jobs/service-rates?${searchParams.toString()}`;
            const response = await handleRequests(
                endpoint,
                {
                    method: 'GET'
                },
                true,
                cancellationToken
            );
            if (response.status !== 200) {
                return null;
            }
            return response.data;
        }
    }
};
